import { ArContainer, ArSprite } from '@aceroll/core';

export class PlatformLogo extends ArContainer {
	#logo;

	constructor() {
		super('logo-platform');
		this.#logo = ArSprite.from('preloader-platform_logo');
		this.#logo.anchor.set(0.5);
		this.#logo.position.set(0, 0);

		this.addChild(this.#logo);
	}
}
